import './accordion.css';

import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Header, Trigger} from '@radix-ui/react-accordion';
import React from 'react';

import { cn } from '@/services/utils';

import { Icon } from '../Icon';

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof Trigger>,
  React.ComponentPropsWithoutRef<typeof Trigger>
>(({ className, children, ...props }, ref) => (
    <Header className="tw-flex">
        <Trigger
            ref={ref}
            className={cn(
                `scoped-accordion-header
                 tw-flex
                 tw-flex-1
                 tw-items-center
                 tw-justify-between
                 tw-py-4
                 tw-px-0
                 tw-font-medium
                 tw-bg-transparent
                 tw-border-none
                 tw-cursor-pointer
                 tw-transition-all
                 [&[data-state=open]>svg]:tw-rotate-180`,
                className
            )}
            {...props}
        >
            {children}
            <Icon icon={ChevronDownIcon} variant="dark" size="sm" />
        </Trigger>
    </Header>
));

AccordionTrigger.displayName = Trigger.displayName;

export { AccordionTrigger };
